import TWDSpin from '../../assets/img/logo/twd-loading.svg'

const TWDLoading = () => (
	<div className="flex h-[90vh] w-full items-center justify-around">
		<img src={TWDSpin} className="size-24 animate-spin" />
	</div>
)

export default TWDLoading
